import { el, RedomComponent, text } from "redom";
import { S4Y_GLOBAL } from "../../../globalHelpers";
import { LogHelpers } from "../../../logHelper";
import { CommentListItemComponentData } from "./commentListItemComponentData";
export class CommentListItemComponent implements RedomComponent {

  private logHelper = new LogHelpers('CommentListItemComponent');
  private userElement: HTMLSpanElement;
  private contentElement: HTMLDivElement;
  private timeElement: HTMLSpanElement;
  constructor() {
    this.logHelper.log('Call constructor');
    this.el = el('div', { class: 'video-user-comment' }, [
      el('div', { class: 'title' }, 'Commented'),
      this.contentElement = el('div'),
      el('div', { class: 'meta' }, [
        el('em', [
          this.timeElement = el('span'),
          text(' by '),
          this.userElement = el('a', { href: '#', class: 'user' }),
        ]),
      ]),
    ]);
  }
  el: RedomComponent | HTMLElement | SVGElement;
  update?(item: CommentListItemComponentData, index: number, data: any, context?: any): void {
    this.logHelper.log('Call update');
    this.logHelper.log(item);
    if (item) {
      this.userElement.textContent = item.USERNAME;
      this.contentElement.textContent = item.CONTENT;
      this.timeElement.textContent = item.INSTIST ? new Date(item.INSTIST).toLocaleString(S4Y_GLOBAL.locale, {
        year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric', hour12: false
      }) : '';
    }
  }
  onmount?(): void {
  }
  onremount?(): void {
  }
  onunmount?(): void {
  }
}